export default __webpack_public_path__ + "static/media/check-icon.4b7d112f.svg";